import { baseResponse } from "./helpers/baseResponse";

const eventURL = s => `/api/dynamics/event/${s}`;


export const eventAPI = {
  async confirmReadGuide() {
    const apiResponse = await axios.post(eventURL('read-guide')).catch(r => r.response);
    return baseResponse(apiResponse);
  }
}